import styles from "./Input.module.css";

const Input = ({
  value,
  onChange,
  placeholder,
  type = "text",
  disabled = false,
  maxLength,
  className = "",
  containerClassName = "",
  style = {},
  error = "",
  name,
}) => {
  return (
    <div className={[styles.container, containerClassName].filter(Boolean).join(" ")}>
      <input
        name={name}
        type={type}
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        disabled={disabled}
        maxLength={maxLength}
        style={style}
        className={[
          styles.input,
          error ? styles.errorInput : "",
          className,
        ]
          .filter(Boolean)
          .join(" ")}
      />
      {!!error && <p className={styles.errorText}>{error}</p>}
    </div>
  );
};

export default Input;
